import type { ComponentProps } from 'react'

import { useTranslation } from 'react-i18next'

import { HeaderUltimaAtualizacao } from '@/shared/components/header-ultima-atualizacao'
import { Icon } from '@/shared/components/icon'
import { Button } from '@/shared/components/ui'
import { LegendasEspelhoDeVendas, type ILegendaItem } from '@/shared/components/ui/legendas-espelho-de-vendas'

interface IHeaderListaEspelhoDeVendas extends ComponentProps<typeof HeaderUltimaAtualizacao> {
  refresh: VoidFunction
  isRefreshing: boolean
  legendas?: ILegendaItem[]
}

export const HeaderListaEspelhoDeVendas = ({
  isRefreshing = false,
  refresh,
  legendas,
  ...props
}: IHeaderListaEspelhoDeVendas) => {
  const { t } = useTranslation('espelho-de-vendas')
  return (
    <div className="flex items-center justify-between py-4">
      <HeaderUltimaAtualizacao popover={<LegendasEspelhoDeVendas items={legendas} />} {...props} />
      <Button variant="link" onClick={refresh} disabled={isRefreshing} data-disabled={isRefreshing}>
        <span className="hidden sm:inline">{isRefreshing ? t('header.atualizando') : t('header.atualizar')}</span>
        <Icon name="refresh-ccw" data-loading={isRefreshing} className="data-[loading=true]:animate-spin" />
      </Button>
    </div>
  )
}
